import AdminSession from "../libs/AdminSession";
import { authAPI, authQuimera } from "./axios";

// -- PRIVATE
const getHeader = () => ({
  headers: {
    Authorization: "Bearer " + AdminSession.getToken(),
  },
});

// --- PUBLIC
const loginRequest = (values) =>
  authAPI.post("/oauth/token", {
    ...values,
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
    grant_type: "password",
    scope: "*",
  });

const CheckToken = () => authAPI.get("/oauth/token/check", getHeader());

const confirmaBO = (id, values) =>
  authQuimera.put("dispositivos/pendentes/" + id, values, getHeader());

const DispPendentes = () => authQuimera.get("dispositivos/pendentes", getHeader());

const loadDispositivosByImei = (imei) => authQuimera.get("dispositivo/imei/" + imei, getHeader());

const apis = {
  loginRequest,
  CheckToken,
  confirmaBO,
  DispPendentes,
  loadDispositivosByImei,
};

export default apis;



// WEBPACK FOOTER //
// ./src/services/Admin.js